import { render, staticRenderFns } from "./logisticsOrderList.vue?vue&type=template&id=3e316b97&scoped=true"
import script from "./logisticsOrderList.vue?vue&type=script&lang=js"
export * from "./logisticsOrderList.vue?vue&type=script&lang=js"
import style0 from "./logisticsOrderList.vue?vue&type=style&index=0&id=3e316b97&lang=scss"
import style1 from "./logisticsOrderList.vue?vue&type=style&index=1&id=3e316b97&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e316b97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e316b97')) {
      api.createRecord('3e316b97', component.options)
    } else {
      api.reload('3e316b97', component.options)
    }
    module.hot.accept("./logisticsOrderList.vue?vue&type=template&id=3e316b97&scoped=true", function () {
      api.rerender('3e316b97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/logisticsOrderList.vue"
export default component.exports